import { Fancyapps } from "@Libraries/Fancyapps";
import "./Sezzle.scss";

export class Sezzle
{
	public BindInformationLink = (element?: HTMLElement): void =>
	{
		element.addEventListener("click", this.DisplayInformation);
	};

	public DisplayInformation = async (e?: Event): Promise<void> =>
	{
		if (typeof e !== "undefined")
		{
			e.preventDefault();
		}

		const fancyapps = await Fancyapps.Import();
		const fancybox = new fancyapps.Fancybox(
			[
				{
					src: "/cart/sezzle-info.html",
					type: "iframe"
				}
			],
			{
				mainClass: "sezzle-info"
			}
		);
	};
}